/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AssetFinancialHoldingKind = {
    BuildingSavingsContract: 'BuildingSavingsContract',
    SavingsAccount: 'SavingsAccount',
    LifeInsurance: 'LifeInsurance',
    PensionInsurance: 'PensionInsurance',
    SecuritiesDepot: 'SecuritiesDepot'
} as const;
export type AssetFinancialHoldingKind = typeof AssetFinancialHoldingKind[keyof typeof AssetFinancialHoldingKind];


export function instanceOfAssetFinancialHoldingKind(value: any): boolean {
    for (const key in AssetFinancialHoldingKind) {
        if (Object.prototype.hasOwnProperty.call(AssetFinancialHoldingKind, key)) {
            if (AssetFinancialHoldingKind[key as keyof typeof AssetFinancialHoldingKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AssetFinancialHoldingKindFromJSON(json: any): AssetFinancialHoldingKind {
    return AssetFinancialHoldingKindFromJSONTyped(json, false);
}

export function AssetFinancialHoldingKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetFinancialHoldingKind {
    return json as AssetFinancialHoldingKind;
}

export function AssetFinancialHoldingKindToJSON(value?: AssetFinancialHoldingKind | null): any {
    return value as any;
}

export function AssetFinancialHoldingKindToJSONTyped(value: any, ignoreDiscriminator: boolean): AssetFinancialHoldingKind {
    return value as AssetFinancialHoldingKind;
}

